var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurveyId(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1.46968C1 1.19242 1.22386 0.967651 1.5 0.967651H14.5C14.7761 0.967651 15 1.19242 15 1.46968V16.5304C15 16.8077 14.7761 17.0324 14.5 17.0324H1.5C1.22386 17.0324 1 16.8077 1 16.5304V1.46968ZM2 1.9717V16.0284H14V1.9717H2ZM4.5 4.98385H11.5C11.7761 4.98385 12 4.75908 12 4.48182C12 4.20456 11.7761 3.9798 11.5 3.9798H4.5C4.22386 3.9798 4 4.20456 4 4.48182C4 4.75908 4.22386 4.98385 4.5 4.98385ZM11.5 7.99599H4.5C4.22386 7.99599 4 7.77123 4 7.49397C4 7.21671 4.22386 6.99194 4.5 6.99194H11.5C11.7761 6.99194 12 7.21671 12 7.49397C12 7.77123 11.7761 7.99599 11.5 7.99599ZM4.5 11.0081H11.5C11.7761 11.0081 12 10.7834 12 10.5061C12 10.2289 11.7761 10.0041 11.5 10.0041H4.5C4.22386 10.0041 4 10.2289 4 10.5061C4 10.7834 4.22386 11.0081 4.5 11.0081ZM7.5 14.0203H4.5C4.22386 14.0203 4 13.7955 4 13.5183C4 13.241 4.22386 13.0162 4.5 13.0162H7.5C7.77614 13.0162 8 13.241 8 13.5183C8 13.7955 7.77614 14.0203 7.5 14.0203Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyId);
export default __webpack_public_path__ + "static/media/survey-id.ae9b87e66a53fb9157d504dbd1368a54.svg";
export { ForwardRef as ReactComponent };